"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageOne;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _FinancialPlanningCheckupFormControls = require("./FinancialPlanningCheckupFormControls");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _Sailboat = _interopRequireDefault(require("./svg/Sailboat"));
var _HandsDollarSign = _interopRequireDefault(require("./svg/HandsDollarSign"));
var _House = _interopRequireDefault(require("./svg/House"));
var _BarUpChart = _interopRequireDefault(require("./svg/BarUpChart"));
var _Graduate = _interopRequireDefault(require("./svg/Graduate"));
var _Shield = _interopRequireDefault(require("./svg/Shield"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function FPCTPageOne() {
  var {
    values: {
      isPlanningRetirementGoal,
      isTransitioningWealthGoal,
      isSavingForMajorPurchaseGoal,
      isBuildWealthGoal,
      isSavingForEducationExpensesGoal,
      isFamilyFinanciallySecureGoal
    },
    setFieldValue,
    values
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    /* istanbul ignore next */
    if (values.hasNavigatedPage) {
      document.getElementById(_FinancialPlanningCheckupWizardTool.calcName).scrollIntoView();
      /* istanbul ignore else */
      if (window) {
        window.scrollBy(0, -112);
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, "Establish goals"), /*#__PURE__*/_react.default.createElement("p", null, "Having a plan in place is a great first step toward meeting your financial goals. Use this check-up to pinpoint areas where we can help you solidify your financial future with customized guidance."), /*#__PURE__*/_react.default.createElement("p", null, "Select the goals that matter most to you."), /*#__PURE__*/_react.default.createElement("div", {
    className: "row row-padding-x"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4 fpct-screen-1-goals"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-screen-1 checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-9 col-lg-9"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.PlanningRetirementGoalCheckBox, {
    isPlanningRetirementGoal: isPlanningRetirementGoal,
    setFieldValue: setFieldValue,
    goalsList: values.goalsList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm-3 col-lg mm-text-right"
  }, /*#__PURE__*/_react.default.createElement(_Sailboat.default, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4 fpct-screen-1-goals"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-screen-1 checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-9 col-lg-9"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.TransitionWealthGoalCheckBox, {
    isTransitioningWealthGoal: isTransitioningWealthGoal,
    setFieldValue: setFieldValue,
    goalsList: values.goalsList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm-3 col-lg mm-text-right"
  }, /*#__PURE__*/_react.default.createElement(_HandsDollarSign.default, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4 fpct-screen-1-goals"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-screen-1 checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-9 col-lg-9"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.SaveForMajorPurchaseGoalCheckBox, {
    isSavingForMajorPurchaseGoal: isSavingForMajorPurchaseGoal,
    setFieldValue: setFieldValue,
    goalsList: values.goalsList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm-3 col-lg mm-text-right"
  }, /*#__PURE__*/_react.default.createElement(_House.default, null)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row archetype-spacing--normal row-padding-x"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4 fpct-screen-1-goals"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-screen-1 checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-9 col-lg-9"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.BuildWealthMaxInvestmentsCheckBox, {
    isBuildWealthGoal: isBuildWealthGoal,
    setFieldValue: setFieldValue,
    goalsList: values.goalsList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm-3 col-lg mm-text-right"
  }, /*#__PURE__*/_react.default.createElement(_BarUpChart.default, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4 fpct-screen-1-goals"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-screen-1 checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-9 col-lg-9"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.SaveForEducationalExpensesGoalCheckBox, {
    isSavingForEducationExpensesGoal: isSavingForEducationExpensesGoal,
    setFieldValue: setFieldValue,
    goalsList: values.goalsList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm-3 col-lg mm-text-right"
  }, /*#__PURE__*/_react.default.createElement(_Graduate.default, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-lg-4 fpct-screen-1-goals"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fpct-screen-1 checkbox-container card-option flex-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-9 col-lg-9"
  }, /*#__PURE__*/_react.default.createElement(_FinancialPlanningCheckupFormControls.EnsureFamilyFinanciallySecureGoalCheckBox, {
    isFamilyFinanciallySecureGoal: isFamilyFinanciallySecureGoal,
    setFieldValue: setFieldValue,
    goalsList: values.goalsList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm-3 col-lg mm-text-right"
  }, /*#__PURE__*/_react.default.createElement(_Shield.default, null)))))));
}